import React from 'react';

export function Test() {
	return <div>Here is a test component</div>;
}